import { createAction } from '@reduxjs/toolkit';

import type {
    ReadonlySlideTranslatedText,
    ReadonlySupportedLanguage,
} from 'js/src/data/translations/translations-types';
import { TRANSLATIONS_ACTIONS } from 'js/src/data/translations/translations-types';

export const storeVideoTranslations = createAction<{
    translations: readonly ReadonlySlideTranslatedText[];
}>(TRANSLATIONS_ACTIONS.STORE_TRANSLATIONS);

export const storeSupportedLanguages = createAction<{
    supported_languages: readonly ReadonlySupportedLanguage[];
}>(TRANSLATIONS_ACTIONS.STORE_SUPPORTED_LANGUAGES);
